/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { CampaignFooter } from '@xsf/shared-lib/components/campaign-footer';
import { Chatbot } from '@xsf/shared-lib/components/chat-bot';
import { CounterWithSorting } from '@xsf/shared-lib/components/counter-with-sorting';
import { Footer } from '@xsf/shared-lib/components/footer';
import { Subscription } from '@xsf/shared-lib/components/footer';
import { Header } from '@xsf/shared-lib/components/header';
import { LocationSearchForm } from '@xsf/shared-lib/components/location-search-form';
import { NotFoundDetailsSection } from '@xsf/shared-lib/components/not-found-details-section';
import { OfficeHours } from '@xsf/shared-lib/components/office-hours';
import { OneColumnLayout } from '@xsf/shared-lib/components/one-column-layout';
import { PageCount } from '@xsf/shared-lib/components/page-count';
import { PageTitleBanner } from '@xsf/shared-lib/components/page-title-banner';
import { PageTitleBannerLarge } from '@xsf/shared-lib/components/page-title-banner-large';
import { PhoneNumber } from '@xsf/shared-lib/components/phone-number';
import { RichTextBlock } from '@xsf/shared-lib/components/rich-text-block';
import { Section } from '@xsf/shared-lib/components/section';
import { SectionBlock } from '@xsf/shared-lib/components/section';
import { SharedTabs } from '@xsf/shared-lib/components/shared-tabs';
import { StatusBlock } from '@xsf/shared-lib/components/status-block';
import { Typeahead } from '@xsf/shared-lib/components/typeahead';
import { ActivityLog } from '@xsf/mho-core/components/activity-log';
import { MhoAccordionBlock } from '@xsf/mho-core/components/mho-accordion-block';
import { MhoCarePreferences } from '@xsf/mho-core/components/mho-care-preferences';
import { MhoEmergencyContact } from '@xsf/mho-core/components/mho-emergency-contact';
import { MhoFooter } from '@xsf/mho-core/components/mho-footer';
import { MhoHealthLinks } from '@xsf/mho-core/components/mho-health-links';
import { MhoInactivityAlert } from '@xsf/mho-core/components/mho-inactivity-alert';
import { MhoInsuranceAndPhotoId } from '@xsf/mho-core/components/mho-insurance-and-photo-id';
import { MhoLoggedInHeader } from '@xsf/mho-core/components/mho-logged-in-header';
import { MhoManageRelationshipsProxy } from '@xsf/mho-core/components/mho-manage-relationships-proxy';
import { MhoProfileCard } from '@xsf/mho-core/components/mho-profile-card';
import { MhoProfileGeneralInformation } from '@xsf/mho-core/components/mho-profile-general-information';
import { SharedHorizontalTabs } from '@xsf/mho-core/components/mho-shared-horizontal-tabs';
import { MhoTabs } from '@xsf/mho-core/components/mho-tabs';
import { MhoTimeoutErrorAlert } from '@xsf/mho-core/components/mho-timeout-error-alert';
import { MhoTopNavigation } from '@xsf/mho-core/components/mho-top-navigation';

import * as AnalyticsContext from 'src/components/AnalyticsContext';
import * as MetaElements from 'src/components/MetaElements';
import * as Metadata from 'src/components/Metadata';
import * as OASAnalyticsContext from 'src/components/OASAnalyticsContext';
import * as OASBooking from 'src/components/OASBooking';
import * as OASConfirmation from 'src/components/OASConfirmation';
import * as OASLandingSearch from 'src/components/OASLandingSearch';
import * as OASListing from 'src/components/OASListing';
import * as OASMetaElements from 'src/components/OASMetaElements';
import * as OASMetadata from 'src/components/OASMetadata';
import * as OASOrganizationSchema from 'src/components/OASOrganizationSchema';
import * as OASPageTitleBanner from 'src/components/OASPageTitleBanner';
import * as OASPhysicianProfile from 'src/components/OASPhysicianProfile';

export const components = new Map();
components.set('CampaignFooter', CampaignFooter);
components.set('Chatbot', Chatbot);
components.set('CounterWithSorting', CounterWithSorting);
components.set('Footer', Footer);
components.set('Subscription', Subscription);
components.set('Header', Header);
components.set('LocationSearchForm', LocationSearchForm);
components.set('NotFoundDetailsSection', NotFoundDetailsSection);
components.set('OfficeHours', OfficeHours);
components.set('OneColumnLayout', OneColumnLayout);
components.set('PageCount', PageCount);
components.set('PageTitleBanner', PageTitleBanner);
components.set('PageTitleBannerLarge', PageTitleBannerLarge);
components.set('PhoneNumber', PhoneNumber);
components.set('RichTextBlock', RichTextBlock);
components.set('Section', Section);
components.set('SectionBlock', SectionBlock);
components.set('SharedTabs', SharedTabs);
components.set('StatusBlock', StatusBlock);
components.set('Typeahead', Typeahead);
components.set('ActivityLog', ActivityLog);
components.set('MhoAccordionBlock', MhoAccordionBlock);
components.set('MhoCarePreferences', MhoCarePreferences);
components.set('MhoEmergencyContact', MhoEmergencyContact);
components.set('MhoFooter', MhoFooter);
components.set('MhoHealthLinks', MhoHealthLinks);
components.set('MhoInactivityAlert', MhoInactivityAlert);
components.set('MhoInsuranceAndPhotoId', MhoInsuranceAndPhotoId);
components.set('MhoLoggedInHeader', MhoLoggedInHeader);
components.set('MhoManageRelationshipsProxy', MhoManageRelationshipsProxy);
components.set('MhoProfileCard', MhoProfileCard);
components.set('MhoProfileGeneralInformation', MhoProfileGeneralInformation);
components.set('SharedHorizontalTabs', SharedHorizontalTabs);
components.set('MhoTabs', MhoTabs);
components.set('MhoTimeoutErrorAlert', MhoTimeoutErrorAlert);
components.set('MhoTopNavigation', MhoTopNavigation);

components.set('AnalyticsContext', AnalyticsContext);
components.set('MetaElements', MetaElements);
components.set('Metadata', Metadata);
components.set('OASAnalyticsContext', OASAnalyticsContext);
components.set('OASBooking', OASBooking);
components.set('OASConfirmation', OASConfirmation);
components.set('OASLandingSearch', OASLandingSearch);
components.set('OASListing', OASListing);
components.set('OASMetaElements', OASMetaElements);
components.set('OASMetadata', OASMetadata);
components.set('OASOrganizationSchema', OASOrganizationSchema);
components.set('OASPageTitleBanner', OASPageTitleBanner);
components.set('OASPhysicianProfile', OASPhysicianProfile);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
